import styled, { css } from 'styled-components';
import { media, Column } from '@simplywallst/ui-core';

const spacing = css`
  > div {
    position: relative;
    margin: 0 ${({ theme }) => theme.x1spacePx}px;
  }
  &:first-child {
    > div {
      margin-left: 0;
    }
  }
  &:last-child {
    > div {
      margin-right: 0;
    }
  }
`;

export const ChartTitle = styled('h4')`
  ${({ theme }) => theme.typography.baseStrong}
  text-transform: capitalize;
  color: ${({ theme }) => theme.color.white};
`;

interface WrapperProps {
  canStack?: boolean;
}

export const Wrapper = styled(Column)<WrapperProps>`
  ${({ canStack }) => !canStack && spacing}
  ${media.mdUp`
    ${spacing}
  `};
`;

export const Chart = styled('div')`
  position: relative;
  padding: 0 ${({ theme }) => theme.x1spacePx}px;
  > svg {
    display: block;
    overflow: visible;
  }
`;

export const Axis = styled('div')`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  > svg {
    display: block;
  }
`;

export const Title = styled('span')<{ color?: string }>`
  ${({ color }) => color && `color ${color}`};
`;

export const TitleTooltip = styled('span')<{ color?: string }>`
  border-bottom: 1px dotted ${(props) => props.theme.color.brand01};
  cursor: help;
  overflow-wrap: break-word;
  ${({ color }) => color && `color ${color}`};
`;
